import { flow, Instance, types } from 'mobx-state-tree';
import { AuthenticationStore } from './AuthenticationStore';
import { LocaleStore } from './LocaleStore';
import { ApplicationStore } from './ApplicationStore';
import { PushNotificationStore } from './PushNotificationStore';
import { PlannerStore } from './PlannerStore';
import { ScoreStore } from './ScoreStore';
import { MatchStore } from './MatchStore';
import { IndictmentStore } from './IndictmentStore';
import { UserStore } from './UserStore';
import { BlackPointStore } from './BlackPointStore';
import { PharmacyStore } from './PharmacyStore';
import { GroupStore } from './GroupStore';
import { SecretariatStore } from './SecretariatStore';
import { SecretariatNeighborStore } from './SecretariatNeighborStore';
import { ModalStore } from './ModalStore';
// import { ExchangeStore } from './DutyExchangeStore';
import { DutyExchangeStore } from './DutyExchangeStore';
import { LanguageStore } from './LanguageStore';
import { DayOfWeekStore } from './DayOfWeekStore';
import { DutyStore } from './DutyStore';
import { DutyTypeStore } from './DutyTypeStore';
import { DutyAssignmentStore } from './DutyAssignmentStore';
import { PharmacyDetailedStore } from './PharmacyDetailedStore';
import { BlackPointTypeStore } from './BlackPointTypeStore';
import { BlackPointStatusStore } from './BlackPointStatusStore';
import { BankHolidayStore } from './BankHolidayStore';
import { BankHolidayDateStore } from './BankHolidayDateStore';
import { DutyOffRequestStore } from './DutyOffRequestStore';
import { SystemStatusStore } from './SystemStatusStore';
import { PharmacyAnnualReviewStore } from './PharmacyAnnualReviewStore';
import { MessageStore } from './MessageStore';
import { DutyExchangeItemStore } from './DutyExchangeItemStore';
import { AnchorStore } from './AnchorStore';
import { UiStore } from './uistore/UiStore';
import { MunicipalityStore } from './MunicipalityStore';
import { ProtectionStore } from './ProtectionStore';
import { TransferRequestStore } from './TransferRequestStore';

export const RootStore = types
  .model('RootStore', {
    AnchorStore: types.optional(AnchorStore, {}),
    ApplicationStore: types.optional(ApplicationStore, {}),
    AuthenticationStore: types.optional(AuthenticationStore, {}),
    PushNotificationStore: types.optional(PushNotificationStore, { userCount: 0, message: '', planningSaved: false, score: '' }),
    BankHolidayStore: types.optional(BankHolidayStore, {}),
    BankHolidayDateStore: types.optional(BankHolidayDateStore, {}),
    BlackPointStatusStore: types.optional(BlackPointStatusStore, {}),
    BlackPointStore: types.optional(BlackPointStore, {}),
    BlackPointTypeStore: types.optional(BlackPointTypeStore, {}),
    DutyAssignmentStore: types.optional(DutyAssignmentStore, {}),
    DutyExchangeStore: types.optional(DutyExchangeStore, {}),
    DutyExchangeItemStore: types.optional(DutyExchangeItemStore, {}),
    DutyOffRequestStore: types.optional(DutyOffRequestStore, {}),
    DutyStore: types.optional(DutyStore, {}),
    DutyTypeStore: types.optional(DutyTypeStore, {}),
    // ExchangeStore: types.optional(ExchangeStore, {}),
    LanguageStore: types.optional(LanguageStore, {}),
    DayOfWeekStore: types.optional(DayOfWeekStore, {}),
    LocaleStore: types.optional(LocaleStore, {}),
    MessageStore: types.optional(MessageStore, {}),
    MunicipalityStore: types.optional(MunicipalityStore, {}),
    ProtectionStore: types.optional(ProtectionStore, {}),
    TransferRequestStore: types.optional(TransferRequestStore, {}),
    ModalStore: types.optional(ModalStore, {}),
    PharmacyAnnualReviewStore: types.optional(PharmacyAnnualReviewStore, {}),
    PharmacyDetailedStore: types.optional(PharmacyDetailedStore, {}),
    PharmacyStore: types.optional(PharmacyStore, { address: "", coordinates: { latitude: 0.0, longitude: 0.0 }}),
    GroupStore: types.optional(GroupStore, {}),
    PlannerStore: types.optional(PlannerStore, {}),
    ScoreStore: types.optional(ScoreStore, {}),
    MatchStore: types.optional(MatchStore, {}),
    IndictmentStore: types.optional(IndictmentStore, {}),
    SecretariatStore: types.optional(SecretariatStore, {}),
    SecretariatNeighborStore: types.optional(SecretariatNeighborStore, {}),
    SystemStatusStore: types.optional(SystemStatusStore, {}),
    UserStore: types.optional(UserStore, {}),
    UiStore: types.optional(UiStore, {}),
  })
  .actions((self) => {
    const afterCreate = flow(function*() {
      // yield self.AuthenticationStore.authenticate();
      yield self.DutyTypeStore.loadList();
    });

    return {
      afterCreate,
    };
  });

export type RootStoreType = Instance<typeof RootStore>;
